<lms-skeleton-app
  *ngIf="!user && !uiService.navigationCompleted"
  [ngClass]="notAvailableForPhone ? 'hideComponent' : ''"
></lms-skeleton-app>
<lms-not-avaliable *ngIf="notAvailableForPhone"></lms-not-avaliable>
<lms-feature-discovery
  *ngIf="!notAvailableForPhone && user && !uiService.microfrontend && uiService.navigationCompleted"
>
</lms-feature-discovery>

<div
  class="wrapper-layout"
  [ngClass]="{
    'small-bar': uiService.navBarSmall,
    'navigation-completed': uiService.navigationCompleted,
    hideComponent: notAvailableForPhone
  }"
>
  <lms-nav *ngIf="user && !uiService.microfrontend" class="wrapper-nav"></lms-nav>
  <lms-job-notifications></lms-job-notifications>
  <main class="main" [ngClass]="{ auth: !user || uiService.microfrontend }" role="main">
    <lms-header *ngIf="user && !uiService.microfrontend" (showCookies)="showCookiesConfig($event)"> </lms-header>
    <lms-preloader *ngIf="isFirstNavigation"></lms-preloader>
    <gl-notice listen></gl-notice>

    <div
      [ngClass]="{
        'main__pad-course': accountPath,
        main__pad: !accountPath,
        'main__pad-iframe': uiService.microfrontend
      }"
    >
      <img class="print-logo" src="/public/img/logo.png" title="Gamelearn Logo" alt="print-logo" />
      <router-outlet></router-outlet>
      <!-- TODO: Do a global breadcrumb with a global layout and remove above lms-preloader -->
    </div>
  </main>
  <lms-footer *ngIf="!uiService.microfrontend" class="footer-wrapper"> </lms-footer>
</div>

<lms-modal #modalWarningMessage class="alert-modal">
  <div class="margin-bottom-none gl-popup__title" [innerHTML]="warningMessage?.title"></div>
  <div class="margin-bottom-none" [innerHTML]="warningMessage?.description"></div>
  <gl-button
    color-secondary
    [text]="'actions.accept' | translate"
    class="right margin-bottom"
    (onClick)="closeModal()"
    form-actions-after
  ></gl-button>
</lms-modal>

<lms-alert></lms-alert>
<lms-toast></lms-toast>
